// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"eda5965d","444":"9eca1c78","635":"b04d33c7"}[chunkId] + ".chunk.js";
};